import { render, staticRenderFns } from "./spinning-img.vue?vue&type=template&id=46eab0f4&scoped=true&"
import script from "./spinning-img.vue?vue&type=script&lang=js&"
export * from "./spinning-img.vue?vue&type=script&lang=js&"
import style0 from "./spinning-img.vue?vue&type=style&index=0&id=46eab0f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46eab0f4",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox, CImage: require('@chakra-ui/vue').CImage})
